import { NgModule } from '@angular/core';
import { ButtonModule } from '@shared/components/button/button.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { SharedModule } from '@shared/shared.module';
import { OtpComponent } from './otp.component';

@NgModule({
	declarations: [OtpComponent],
	imports: [SharedModule, ButtonModule, InputModule],
	exports: [OtpComponent],
})
export class OtpModule {}
